import { render, staticRenderFns } from "./realtime-banner.vue?vue&type=template&id=262a9b3f"
import script from "./realtime-banner.vue?vue&type=script&lang=js"
export * from "./realtime-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports